/* eslint-disable no-underscore-dangle */
import VectorTileSource from 'ol/source/VectorTile';
import { createXYZ, extentFromProjection } from 'ol/tilegrid';
import { getWidth, getHeight } from 'ol/extent';
import { urlGenerator } from '../utils/urlUtils';
import { isoTimeFormatter } from '../utils/DateUtils';
export function getKeyForParams(params) {
  return `${params.view}/${params.element}/${params.forecast}/${params.time}${params.unit ? `/unit=${params.unit}` : ''}${params.plot_extrema ? `/plot_extrema=${params.plot_extrema}` : ''}`;
}

function tileUrlFunction(tileCoord) {
  if (!(Array.isArray(tileCoord) && tileCoord.length)) {
    return null;
  }

  var use_lowres;

  if (this.params.HighResFromZoomLevel !== undefined) {
    use_lowres = tileCoord[0] < this.params.HighResFromZoomLevel;
  } else {
    use_lowres = tileCoord[0] < 5;
  }

  const urlParams = { ...this.params,
    time: this.formatTime(this.params.time),
    z: tileCoord[0],
    x: tileCoord[1],
    y: tileCoord[2],
    use_lowres: use_lowres
  };
  return urlGenerator(urlParams, this.urls[0]);
}

function getTileSizeByExtent(extent, tileSize = 512) {
  if (Array.isArray(tileSize)) {
    return tileSize;
  }

  const width = getWidth(extent);
  const height = getHeight(extent);
  const tw = tileSize;
  const th = tw * height / width;
  return [tw, th];
}

function getCacheSizeByScreen(tileSize) {
  const screenWidth = window.screen.availWidth || window.screen.width;
  const screenHeight = window.screen.availHeight || window.screen.height;
  return 4 * Math.ceil(screenWidth / tileSize[0]) * Math.ceil(screenHeight / tileSize[1]);
}

class VectorTileWMS extends VectorTileSource {
  constructor({
    params,
    cacheSize,
    timeFormatter,
    preloadZoom,
    ...options
  }) {
    const projection = options.projection || 'EPSG:3395';
    const extent = options.extent || extentFromProjection(projection);
    const tileSize = getTileSizeByExtent(extent, options.tileSize);
    const tileGrid = options.tileGrid || createXYZ({
      extent,
      maxZoom: options.maxZoom,
      minZoom: options.minZoom,
      tileSize
    });
    super({ ...options,
      tileGrid,
      cacheSize: cacheSize || getCacheSizeByScreen(tileSize)
    });
    this.params = params || {};
    this.preloadZoom = preloadZoom;
    this.formatTime = timeFormatter || isoTimeFormatter;
    this.isLayerVisibleFn = options.isLayerVisibleFn;
    this.setTileUrlFunction(tileUrlFunction);
    this.updateParams(this.params);
  }

  updateParams(params) {
    Object.assign(this.params, params);
    this.setKey(getKeyForParams(this.params));
  }

}

export default VectorTileWMS;